/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientDto } from './PatientDto';
import {
    PatientDtoFromJSON,
    PatientDtoFromJSONTyped,
    PatientDtoToJSON,
    PatientDtoToJSONTyped,
} from './PatientDto';

/**
 * 
 * @export
 * @interface ProcedureGenerationOutputDto
 */
export interface ProcedureGenerationOutputDto {
    /**
     * Procedure ID
     * @type {string}
     * @memberof ProcedureGenerationOutputDto
     */
    procedureId: string;
    /**
     * Procedure file path (generated by Gemini - DOCX format)
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    procedureTxtPath?: object;
    /**
     * Procedure file URL (generated by Gemini - DOCX format)
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    procedureTxtUrl?: object;
    /**
     * Procedure text generation token usage
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    procedureTxtTokenUsage?: object;
    /**
     * Procedure PDF file path
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    procedurePdfPath?: object;
    /**
     * Download URL for procedure PDF file - signed URL for direct download (temporary, expires in 1 hour)
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    procedurePdfUrl?: object;
    /**
     * Procedure PDF generation token usage
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    procedurePdfTokenUsage?: object;
    /**
     * Timestamp when the procedure was created
     * @type {Date}
     * @memberof ProcedureGenerationOutputDto
     */
    createdAt: Date;
    /**
     * Timestamp when the procedure was last updated
     * @type {Date}
     * @memberof ProcedureGenerationOutputDto
     */
    updatedAt: Date;
    /**
     * Language of the procedure document
     * @type {string}
     * @memberof ProcedureGenerationOutputDto
     */
    language: string;
    /**
     * Description of the procedures taken
     * @type {string}
     * @memberof ProcedureGenerationOutputDto
     */
    proceduresTaken: string;
    /**
     * Additional comments
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    additionalComments?: object;
    /**
     * Feedback
     * @type {object}
     * @memberof ProcedureGenerationOutputDto
     */
    feedback?: object;
    /**
     * Patient information
     * @type {PatientDto}
     * @memberof ProcedureGenerationOutputDto
     */
    patient?: PatientDto;
    /**
     * Is generating
     * @type {boolean}
     * @memberof ProcedureGenerationOutputDto
     */
    isGenerating?: boolean;
    /**
     * Whether the provider has hidden this record from the patient. When true the patient cannot see this procedure.
     * @type {boolean}
     * @memberof ProcedureGenerationOutputDto
     */
    isHiddenFromPatient: boolean;
}

/**
 * Check if a given object implements the ProcedureGenerationOutputDto interface.
 */
export function instanceOfProcedureGenerationOutputDto(value: object): value is ProcedureGenerationOutputDto {
    if (!('procedureId' in value) || value['procedureId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('proceduresTaken' in value) || value['proceduresTaken'] === undefined) return false;
    if (!('isHiddenFromPatient' in value) || value['isHiddenFromPatient'] === undefined) return false;
    return true;
}

export function ProcedureGenerationOutputDtoFromJSON(json: any): ProcedureGenerationOutputDto {
    return ProcedureGenerationOutputDtoFromJSONTyped(json, false);
}

export function ProcedureGenerationOutputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcedureGenerationOutputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'procedureId': json['procedureId'],
        'procedureTxtPath': json['procedureTxtPath'] == null ? undefined : json['procedureTxtPath'],
        'procedureTxtUrl': json['procedureTxtUrl'] == null ? undefined : json['procedureTxtUrl'],
        'procedureTxtTokenUsage': json['procedureTxtTokenUsage'] == null ? undefined : json['procedureTxtTokenUsage'],
        'procedurePdfPath': json['procedurePdfPath'] == null ? undefined : json['procedurePdfPath'],
        'procedurePdfUrl': json['procedurePdfUrl'] == null ? undefined : json['procedurePdfUrl'],
        'procedurePdfTokenUsage': json['procedurePdfTokenUsage'] == null ? undefined : json['procedurePdfTokenUsage'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'language': json['language'],
        'proceduresTaken': json['proceduresTaken'],
        'additionalComments': json['additionalComments'] == null ? undefined : json['additionalComments'],
        'feedback': json['feedback'] == null ? undefined : json['feedback'],
        'patient': json['patient'] == null ? undefined : PatientDtoFromJSON(json['patient']),
        'isGenerating': json['isGenerating'] == null ? undefined : json['isGenerating'],
        'isHiddenFromPatient': json['isHiddenFromPatient'],
    };
}

export function ProcedureGenerationOutputDtoToJSON(json: any): ProcedureGenerationOutputDto {
    return ProcedureGenerationOutputDtoToJSONTyped(json, false);
}

export function ProcedureGenerationOutputDtoToJSONTyped(value?: ProcedureGenerationOutputDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'procedureId': value['procedureId'],
        'procedureTxtPath': value['procedureTxtPath'],
        'procedureTxtUrl': value['procedureTxtUrl'],
        'procedureTxtTokenUsage': value['procedureTxtTokenUsage'],
        'procedurePdfPath': value['procedurePdfPath'],
        'procedurePdfUrl': value['procedurePdfUrl'],
        'procedurePdfTokenUsage': value['procedurePdfTokenUsage'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'language': value['language'],
        'proceduresTaken': value['proceduresTaken'],
        'additionalComments': value['additionalComments'],
        'feedback': value['feedback'],
        'patient': PatientDtoToJSON(value['patient']),
        'isGenerating': value['isGenerating'],
        'isHiddenFromPatient': value['isHiddenFromPatient'],
    };
}

